function addSwatchSelector() {
    
  $('.option-thumb').click(function (){
  updateImage(this)
  
  

  });

}

function updateImage (option){
   var parentOption='SingleOptionSelector-' + $(option).attr('option-parent'); 
    var selectedOption=$(option).attr('data-value');
    $('#' + parentOption).val(selectedOption).change();
    
    
    var configured_image=$('[name="id"]').children("option:selected").attr('configured-image');
    var lead_time=$('[name="id"]').children("option:selected").attr('lead-time');
    var configured_desc=$('[name="id"]').children("option:selected").attr('configured-desc');
 update_config_info(lead_time, configured_desc);
  $('#product-configured-image').val(configured_image);
    load_images(configured_image); 
}


function update_config_info(leadtime, desc){
 $('#configured-product-description').text(desc);
  $('#product-lead-time').text(leadtime);
}
function load_images(configured_image) {

  if (configured_image == '') {
   configured_image='https://teknion.bynder.com/m/44a41cb6e495fab6/original/no_image_available-product.png';
  }
  
  console.log(configured_image);
  $('#configured-product-image').attr('src',configured_image).on('load',function(){
    
  
                        
    this.width;   // Note: $(this).width() will not work for in memory images

}); 
}

$(document).ready(function (){
  var configured_image=$('[name="id"]').children("option:selected").attr('configured-image');
   console.log ('starting defaults...');
    load_images(configured_image);
  console.log ('ending defaults...');
  $('#product-configured-image').val(configured_image);
});